import { Component,HostListener  } from '@angular/core';
import { ApiService } from '../app/services/api.service';
import { CommonEventService } from '../app/services/common-event.service';
import { Router, ActivatedRoute } from '@angular/router';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'one-flow-app';
  idleState = 'Not started.';
  timedOut = false;
  headerShow = true;
  constructor(public apiService : ApiService,
    public commonService : CommonEventService,
    private activatedRoute: ActivatedRoute,
    public idle: Idle,
    private keepalive: Keepalive
    ){
      // sets an idle timeout of 5 seconds, for testing purposes.
      // idle.setIdle(615);
      // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
      // idle.setTimeout(1800);
      // idle.setTimeout(250);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      // idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      // idle.onIdleEnd.subscribe(() => {
      //   this.idleState = 'No longer idle.';
      //   this.commonService.sessionPortalLoad();
      // });
      // idle.onTimeout.subscribe(() => {
      //   this.idleState = 'Timed out!';
      //   this.timedOut = true;
      //   this.commonService.alertCall('Alert!!','Session expired!!');
      //   // this.commonService.goBack();
      // });
      if(location.pathname == '/customQuoteDashboard'){
        this.headerShow = false;
      }
      setTimeout(()=>{
        this.activatedRoute.queryParams.subscribe(params => {
          if(params['data']){
            localStorage.setItem('encData','')
            localStorage.setItem('encData',params['data'])
            localStorage.setItem('fileId',params['fileId'])
            this.apiService.apiMainObj.encUrlData = params['data'];
            if(location.pathname == "/home"){
              this.apiService.getUserDataSession(params['data']).subscribe((resData: any)=>{
                this.commonService.commonMainObj.userSessionMemberId = resData.memberId;
                if(resData && resData.status == "NO_SESSION"){
                  this.commonService.commonMainObj.userData = {};
                  this.commonService.commonMainObj.sessionCheck = false;
                  this.commonService.commonMainObj.isGuestUser = true;
                }else if(resData && resData.status == 'SESSION_FOUND'){
                  this.commonService.commonMainObj.userId = resData.userId
                  this.commonService.commonMainObj.userData = resData;
                  this.commonService.commonMainObj.sessionCheck  = true;
                  this.commonService.commonMainObj.isGuestUser = false;
                }
              },err=>{
                if(err.status == 200){
                  if(err.error.text == "NO_SESSION"){
                    this.commonService.commonMainObj.sessionCheck = false;
                  }else{
                    this.commonService.commonMainObj.userData = {};
                  }
                }
                console.log(err)
              });
            }
          }
        });
      },500)

      this.reset();
    }

    ngOnInit(): void{
      this.commonService.sessionPortalLoad();
      // window.addEventListener("beforeunload", this.onBeforeUnload);
        this.idle.onInterrupt.subscribe(()=>{
          setTimeout(()=>{
            if(this.apiService.apiMainObj.encUrlData != localStorage.getItem('encData')){
              // this.commonService.alertCall('Alert!!','Session is invalid!!');
              this.commonService.goBack();
            }
          },2000)
        });
        // setTimeout(()=>{ window.addEventListener("beforeunload", function (e) {
        //   var confirmationMessage = "\o/";
        //   // console.log("cond", e);
        //   // console.log(confirmationMessage);
        //   e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
        //   return confirmationMessage;              // Gecko, WebKit, Chrome <34
        // });},500);
    }
    // ngOnDestroy() {
    //   window.removeEventListener("beforeunload", this.onBeforeUnload);
    // }
    
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  // @HostListener('window:beforeunload', ['$event'])
  // onBeforeUnload(event: BeforeUnloadEvent) {
  //   // Confirmation message
  //   const confirmationMessage = 'Are you sure you want to leave this page?';
  //   // Set the confirmation message
  //   event.returnValue = confirmationMessage;
  //   // Return the confirmation message
  //   return confirmationMessage;
  // }

  // invalidUserCheck(message:any,text:any,ttle:any){
  //   Swal.fire({
  //     title: '<i class="text-danger">'+ttle+'</i>',
  //     html:message + '<br/> <br/>' + text,
  //     showCancelButton: false,
  //     confirmButtonText: 'Ok',
  //     backdrop:false
  //   }).then((result) => {
  //     if (result['isConfirmed']){
  //       this.commonService.goBack();
  //     }
  //   })
  // }

  // logout(){
  //   this.apiService.logOutUser().subscribe((resUserData: any)=>{
  //     window.location.href="https://staging.protoexpress.com";
  //   });
  // }

}
